import React from 'react';
import { useTranslation } from "react-i18next";


const Form = () => {
      const { t } = useTranslation();
    return (
        <div className="width">
            <form action="https://formspree.io/f/mvgqlvdr" method="POST">
                <div className="row">
                    <div className="col-md-6 col-12">
                        <label htmlFor="prenom">{t('prenom')}</label>
                        <input type="text" id="prenom" name="prenom"  className="form-control" required placeholder={t('prenom')}/>
                    </div>
                    <div className="col-md-6 col-12">
                        <label htmlFor="nom">{t('nom')}</label>
                        <input type="text" id="nom" name="nom"  className="form-control" required placeholder={t('nom')} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-12">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" className="form-control" required  placeholder="Email"/>
                    </div>
                    <div className="col-md-6 col-12">
                        <label htmlFor="telephone">{t('telephone')}</label>
                        <input type="tel" id="telephone" name="telephone" className="form-control"placeholder={t('telephone')}/>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col">
                        <label htmlFor="message">Message</label>
                        <textarea id="message" name="message" rows="5"  className="form-control" required placeholder="Message"></textarea>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                <button type="submit" className="buttonForm text-right">{t('send')}</button>
                </div>
            </form>
        </div>
    );
};

export default Form;
